exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1.paws[data-v-058c9c42]:before{color:#48c2c7;content:\"\\1F43E\";margin-right:1rem}h1.paws[data-v-058c9c42]:after{color:#48c2c7;content:\"\\1F43E\";margin-left:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-058c9c42","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/frontend-vue/components/forms/enquiry-form.vue
// module id = WbKp
// module chunks = 0